import { createSelector } from '@reduxjs/toolkit';

import { getFilterLocation } from '../filters/getFilterLocation';
import { locationsHashSelector } from '../locations/locationsListSelector';

export const moscowCoords = { lat: 55.755814, lng: 37.617635 };

const moscowZoom = 10;

export const getLocationCenterCoordinates = createSelector(
  getFilterLocation,
  locationsHashSelector,
  (location, locationsHash) => {
    const coordinates = locationsHash[location].centerCoordinates;

    if (!coordinates?.lat || !coordinates.lng) {
      return { center: moscowCoords, zoom: moscowZoom };
    }

    const center = { lat: coordinates.lat, lng: coordinates.lng };

    if (!coordinates.scale) {
      return { center, zoom: moscowZoom };
    }

    return { center, zoom: coordinates.scale };
  },
);
